module.exports = __webpack_public_path__ + "3226aefc923842e519f69e30c2e93b3a.png";